import type { AppMessages } from './en';

const sk: AppMessages = {
    app: {
        brand: 'Faust Signing Service',
        suite: 'Wolters Kluwer',
    },
    locale: {
        switch: 'Jazyk',
        cs: 'Čeština',
        sk: 'Slovenčina',
        en: 'English',
    },
    nav: {
        overview: 'Prehľad',
        publications: 'Publikácie',
        files: 'Súbory',
        queue: 'Front',
        users: 'Používatelia',
        processing: 'Spracovanie',
        management: 'Správa',
        monitoring: 'Monitoring',
        oauthApplications: 'OAuth aplikácie',
    },
    menu: {
        overview: 'Prehľad',
        publications: 'Publikácie',
        files: 'Súbory',
        processing: 'Spracovanie',
        pdfWatermarkDb: 'PDF vodoznak (DB)',
        epubSignDb: 'EPUB podpis (DB)',
        monitoring: 'Monitoring',
        users: 'Používatelia',
        invitations: 'Pozvánky',
        oauthApplications: 'OAuth aplikácie',
        applicationManagement: 'Správa aplikácie',
        catalogSync: 'Synchronizácia katalógu',
        massUpload: 'Hromadné nahranie dokumentov',
        verifyPipeline: 'Overenie pipeline',
        fingerprintCheck: 'Kontrola fingerprintu',
    },
    dashboard: {
        heroTitle: 'Prehľadnejšie prostredie pre publikácie, front a overovanie.',
        heroSubtitle:
            'Spravujte publikácie, sledujte front spracovania a overujte výsledky podpisu z jednej konzoly.',
        actionOpenQueue: 'Otvoriť front',
        actionBrowsePublications: 'Prehliadať publikácie',
        cards: {
            publications: {
                title: 'Publikácie',
                description:
                    'Spravujte tituly a vstupné body napájajúce následné spracovanie a overovanie.',
                action: 'Otvoriť publikácie',
            },
            queue: {
                title: 'Front',
                description: 'Sledujte priebeh spracovania, chyby a posledné úlohy na jednom mieste.',
                action: 'Zobraziť front',
            },
            files: {
                title: 'Súbory',
                description:
                    'Prezrite si uložené súbory, exporty a zdrojové aktíva pred spracovaním.',
                action: 'Otvoriť súbory',
            },
            bulkUpload: {
                title: 'Hromadné nahranie',
                description: 'Pripravte a odošlite hromadné nahrania dokumentov pre PDF a EPUB tituly.',
                action: 'Spustiť nahranie',
            },
            verification: {
                title: 'Overenie',
                description:
                    'Skontrolujte celú podpisovú pipeline pred zverejnením výsledkov používateľom.',
                action: 'Spustiť overenie',
            },
            fingerprint: {
                title: 'Fingerprint',
                description:
                    'Overte identitu dokumentu a porovnajte extrahované fingerprinty so známymi záznamami.',
                action: 'Preskúmať fingerprinty',
            },
            users: {
                title: 'Používatelia',
                description:
                    'Udržiavajte operátorov, pozvánky a OAuth aplikácie v predvídateľnom administrátorskom rozhraní.',
                action: 'Spravovať používateľov',
            },
            operations: {
                title: 'Operácie',
                description: 'Spúšťajte synchronizáciu katalógu a ďalšie prevádzkové nástroje z jedného miesta.',
                action: 'Otvoriť operácie',
            },
        },
    },
    auth: {
        login: {
            subtitle: 'Prihláste sa pre pokračovanie do konzoly',
            email: 'E-mail',
            password: 'Heslo',
            submit: 'Prihlásiť sa',
            submitting: 'Prihlasovanie…',
            invalidCredentials: 'Neplatný e-mail alebo heslo',
        },
        changePassword: {
            menuItem: 'Zmeniť heslo',
            titleSelf: 'Zmena vášho hesla',
            titleAdmin: 'Zmena hesla používateľa %{name}',
            adminNotice: 'Meníte heslo používateľa: %{name}',
            fields: {
                oldPassword: 'Staré heslo',
                newPassword: 'Nové heslo',
                confirmPassword: 'Potvrdiť heslo',
            },
            requirementsTitle: 'Požiadavky na heslo:',
            requirements: {
                length: 'Aspoň 8 znakov',
                uppercase: 'Aspoň 1 veľké písmeno',
                lowercase: 'Aspoň 1 malé písmeno',
                digit: 'Aspoň 1 číslica',
            },
            actions: {
                cancel: 'Zrušiť',
                submit: 'Zmeniť heslo',
                submitting: 'Mením…',
            },
            notifications: {
                authRequired: 'Vyžaduje sa prihlásenie',
                success: 'Heslo bolo úspešne zmenené',
                relogin: 'Prihláste sa prosím znova pomocou nového hesla',
                failed: 'Zmena hesla zlyhala',
            },
            errors: {
                oldPasswordRequired: 'Zadajte staré heslo',
                newPasswordRequired: 'Zadajte nové heslo',
                tooShort: 'Heslo musí mať aspoň 8 znakov',
                missingUppercase: 'Musí obsahovať veľké písmeno',
                missingLowercase: 'Musí obsahovať malé písmeno',
                missingDigit: 'Musí obsahovať číslicu',
                confirmRequired: 'Vyžaduje sa potvrdenie hesla',
                mismatch: 'Heslá sa nezhodujú',
            },
        },
        defaultUser: 'Používateľ',
    },
    actions: {
        exportCsv: 'Export do CSV',
        copyCode: 'Kopírovať kód',
        done: 'Hotovo',
        copy: 'Kopírovať',
        download: 'Stiahnuť',
        refresh: 'Obnoviť',
        apply: 'Použiť',
        clear: 'Vyčistiť',
        all: 'Všetko',
    },
    notifications: {
        authRequired: 'Vyžaduje sa prihlásenie',
        copiedToClipboard: 'Skopírované do schránky',
        downloadSuccess: 'Súbor bol úspešne stiahnutý',
        downloadFailed: 'Stiahnutie súboru zlyhalo',
    },
    permissions: {
        noAccess: 'Nemáte oprávnenie na zobrazenie tejto sekcie.',
    },
    resources: {
        users: {
            name: 'Používateľ |||| Používatelia',
            fields: {
                id: 'ID',
                email: 'E-mail',
                full_name: 'Meno a priezvisko',
                is_active: 'Aktívny',
                is_admin: 'Administrátor',
                created_at: 'Vytvorené',
                updated_at: 'Upravené',
                password: 'Heslo',
                invite_code: 'Kód pozvánky',
                role: 'Rola',
            },
            filters: {
                emailPlaceholder: 'Filter podľa e-mailu',
            },
            empty: {
                title: 'Žiadni používatelia',
                hint: 'Vytvorte nového používateľa alebo niekoho pozvite.',
            },
            actions: {
                changePassword: 'Zmeniť heslo',
            },
            helpers: {
                passwordKeepCurrent: 'Nechajte prázdne pre zachovanie aktuálneho hesla',
                inviteCode: 'Kód pozvánky pre tohto používateľa',
            },
            roles: {
                admin: 'Administrátor',
                user: 'Používateľ',
            },
            notifications: {
                exportSuccess: 'Používatelia boli úspešne exportovaní',
                exportFailed: 'Export používateľov zlyhal',
                fetchFailed: 'Načítanie používateľov zlyhalo',
            },
        },
        invitations: {
            name: 'Pozvánka |||| Pozvánky',
            fields: {
                id: 'ID',
                email: 'E-mail',
                code: 'Kód',
                is_active: 'Aktívna',
                is_admin: 'Administrátorské oprávnenia',
                invited_by: 'Pozval/a',
                created_at: 'Vytvorené',
                expires_at: 'Vyprší',
            },
            filters: {
                emailPlaceholder: 'Filter podľa e-mailu',
            },
            empty: {
                title: 'Žiadne pozvánky',
                hint: 'Vytvorte novú pozvánku tlačidlom „Vytvoriť" hore.',
            },
            actions: {
                createInvitation: 'Vytvoriť pozvánku',
            },
            notifications: {
                codeCopied: 'Kód pozvánky skopírovaný do schránky',
                codeCopyFailed: 'Skopírovanie kódu pozvánky zlyhalo',
                exportSuccess: 'Pozvánky boli úspešne exportované',
                exportFailed: 'Export pozvánok zlyhal',
                fetchFailed: 'Načítanie pozvánok zlyhalo',
            },
            permissionDenied: {
                view: 'Nemáte oprávnenie na zobrazenie pozvánok.',
                viewDetails: 'Nemáte oprávnenie na zobrazenie detailu pozvánky.',
                create: 'Nemáte oprávnenie na vytváranie pozvánok.',
            },
        },
        'oauth-applications': {
            name: 'OAuth aplikácia |||| OAuth aplikácie',
            fields: {
                name: 'Názov aplikácie',
                description: 'Popis',
                client_id: 'Client ID',
                client_secret: 'Client Secret',
                scopes: 'Scopes',
                is_active: 'Aktívna',
                created_at: 'Vytvorené',
            },
            permissionDenied: {
                manage: 'OAuth aplikácie môžu spravovať iba administrátori.',
                view: 'OAuth aplikácie môžu zobraziť iba administrátori.',
            },
            helpers: {
                scopesCreate: 'Vyberte scope oprávnenia pre aplikáciu (Ctrl/Cmd pre výber viacerých)',
                scopesEdit: 'Ctrl/Cmd pre výber viacerých',
            },
            notifications: {
                created: 'OAuth aplikácia bola úspešne vytvorená',
            },
            secretDialog: {
                title: '⚠️ Uložte si OAuth prihlasovacie údaje',
                alertBoldLabel: 'Dôležité:',
                alertText:
                    'Toto je JEDINÁ príležitosť zobraziť client secret. Uložte si ho bezpečne teraz — neskôr ho nepôjde získať späť!',
            },
        },
        publications: {
            name: 'Publikácia |||| Publikácie',
            fields: {
                id: 'ID',
                sku: 'SKU',
                title: 'Názov',
                description: 'Popis',
                created_at: 'Vytvorené',
                updated_at: 'Upravené',
            },
            filters: {
                skuPlaceholder: 'Filter podľa SKU',
                titlePlaceholder: 'Filter podľa názvu',
            },
            empty: {
                title: 'Žiadne publikácie',
                hint: 'Vytvorte novú publikáciu tlačidlom „Vytvoriť“ hore.',
            },
            helpers: {
                skuUnique: 'Unikátny identifikátor publikácie',
            },
            relatedFilesLabel: 'Súbory',
            notifications: {
                exportSuccess: 'Publikácie boli úspešne exportované',
                exportFailed: 'Export publikácií zlyhal',
                fetchFailed: 'Načítanie publikácií zlyhalo',
            },
        },
        files: {
            name: 'Súbor |||| Súbory',
            fields: {
                id: 'ID',
                publication_id: 'Publikácia',
                file_type: 'Typ',
                filename: 'Názov súboru',
                mime_type: 'MIME typ',
                size: 'Veľkosť',
                uploaded_by: 'Nahral/a',
                created_at: 'Vytvorené',
                updated_at: 'Upravené',
            },
            filters: {
                skuPlaceholder: 'Filter podľa SKU',
                filenamePlaceholder: 'Filter podľa názvu súboru',
            },
            empty: {
                title: 'Žiadne súbory',
                hint: 'Nahrajte súbor tlačidlom „Vytvoriť“ hore.',
            },
            create: {
                title: 'Nahrať súbor',
                saveLabel: 'Nahrať súbor',
                savingLabel: 'Nahrávanie…',
                loadingPublications: 'Načítam publikácie…',
                selectPublicationPlaceholder: 'Vyberte publikáciu',
            },
            form: {
                publication: 'Publikácia',
                exactSku: 'Presné SKU',
                fileType: 'Typ súboru',
                file: 'Súbor',
                selectFileButton: 'Vybrať súbor',
            },
            helpers: {
                publication: 'Vyberte publikáciu podľa SKU alebo názvu, prípadne zadajte presné SKU nižšie.',
                exactSku: 'Volitelné. Ak je vyplnené, použije sa namiesto vybranej publikácie toto presné SKU.',
                file: 'Podporované typy súborov: PDF, EPUB',
            },
            fileTypes: {
                pdf: 'PDF',
                epub: 'EPUB',
            },
            notifications: {
                publicationsLoadFailed: 'Načítanie publikácií zlyhalo',
                exportSuccess: 'Súbory boli úspešne exportované',
                exportFailed: 'Export súborov zlyhal',
                uploadSuccess: 'Súbor bol úspešne nahraný',
                uploadFailedPrefix: 'Nahratie zlyhalo',
                selectFile: 'Vyberte súbor na nahratie',
                selectPublicationOrSku: 'Vyberte publikáciu alebo zadajte presné SKU',
                selectFileType: 'Vyberte typ súboru',
            },
        },
        queue: {
            name: 'Položka frontu |||| Položky frontu',
            fields: {
                queue_id: 'Queue ID',
                sku: 'SKU',
                processing_type: 'Typ',
                status: 'Stav',
                progress: 'Priebeh',
                consumer_name: 'Meno',
                consumer_surname: 'Priezvisko',
                consumer_address: 'Adresa',
                consumer_telephone: 'Telefón',
                consumer_email: 'E-mail',
                error_code: 'Kód chyby',
                error_message: 'Správa chyby',
                backchannel_url: 'Backchannel URL',
                created_at: 'Vytvorené',
                updated_at: 'Upravené',
            },
            empty: {
                title: 'Žiadne položky frontu',
                hint: 'Odošlite dokumenty na spracovanie tlačidlom „Vytvoriť“ hore.',
            },
            create: {
                title: 'Podpísať dokument',
                saveLabel: 'Odoslať na podpis',
            },
            sections: {
                document: 'Informácie o dokumente',
                consumer: 'Informácie o príjemcovi',
                optional: 'Volitelné nastavenia',
            },
            form: {
                processingType: 'Typ spracovania',
                publicationSku: 'SKU publikácie',
                firstName: 'Meno',
                lastName: 'Priezvisko',
                address: 'Adresa',
                telephone: 'Telefón',
                email: 'E-mail',
                backchannelUrl: 'Backchannel URL',
            },
            helpers: {
                backchannelUrl: 'Volitelná callback URL pre notifikácie po dokončení spracovania',
            },
            processingTypes: {
                watermark: 'PDF watermark',
                sign: 'EPUB podpis',
            },
            statuses: {
                pending: 'V rade',
                processing: 'Spracováva sa',
                completed: 'Dokončené',
                error: 'Chyba',
                unknown: 'Neznámy',
            },
            actions: {
                refresh: 'Obnoviť',
                download: 'Stiahnuť',
            },
            notifications: {
                statusRefreshed: 'Stav obnovený',
                downloadSuccess: 'Súbor úspešne stiahnutý',
                downloadFailed: 'Stiahnutie súboru zlyhalo',
                signFailedPrefix: 'Podpis zlyhal',
                queuedSuccess: 'Dokument bol úspešne zaradený do frontu. Queue ID: %{queueId}',
            },
            summaryText: 'Dokument bude spracovaný asynchrónne. Stav môžete sledovať vo fronte.',
        },
    },
    monitoring: {
        title: 'Monitoring',
        stats: {
            total: 'Celkom',
            today: 'Dnes',
            thisWeek: 'Tento týždeň',
            thisMonth: 'Tento mesiac',
            doneToday: 'Dokončené dnes',
            errorsToday: 'Chyby dnes',
        },
        charts: {
            daily: 'Denné požiadavky (posledných 30 dní)',
            dailyTotal: 'Celkom',
            dailyCompleted: 'Dokončené',
            dailyErrors: 'Chyby',
            statusDistribution: 'Rozloženie stavov',
        },
        filters: {
            title: 'Filtre',
            sku: 'SKU',
            consumerEmail: 'E-mail príjemcu',
            status: 'Stav',
            processingType: 'Typ spracovania',
            documentType: 'Typ dokumentu',
        },
        processingTypes: {
            watermark: 'Watermark',
            sign: 'Podpis',
        },
        documentTypes: {
            pdf: 'PDF',
            epub: 'EPUB',
        },
        table: {
            queueId: 'Queue ID',
            operator: 'Operátor',
            sku: 'SKU',
            consumerEmail: 'E-mail príjemcu',
            type: 'Typ',
            doc: 'Dok.',
            status: 'Stav',
            progress: 'Priebeh',
            created: 'Vytvorené',
            completed: 'Dokončené',
            empty: 'Žiadne záznamy',
        },
        detail: {
            title: 'Detail požiadavky',
            queueId: 'Queue ID',
            status: 'Stav',
            progress: 'Priebeh',
            operator: 'Operátor',
            sku: 'SKU',
            consumerEmail: 'E-mail príjemcu',
            processingType: 'Typ spracovania',
            documentType: 'Typ dokumentu',
            createdAt: 'Vytvorené',
            startedAt: 'Začaté',
            completedAt: 'Dokončené',
            errorCode: 'Kód chyby',
            errorMessage: 'Správa chyby',
            downloadProcessed: 'Stiahnuť spracovaný dokument',
        },
        notifications: {
            loadFailed: 'Načítanie dát monitoringu zlyhalo',
            sseInterrupted: 'Spojenie pre živý monitoring prerušené',
            downloadSuccess: 'Úspešne stiahnuté',
            downloadFailed: 'Stiahnutie zlyhalo',
        },
        tooltips: {
            refresh: 'Obnoviť',
            download: 'Stiahnuť',
        },
    },
    processing: {
        pdf: {
            title: 'PDF watermark (súbor z databázy)',
            heading: 'Watermark PDF z databázy',
            description: 'Vyberte publikáciu a zadajte údaje príjemcu pre zaradenie PDF watermarku do frontu.',
            actionLabel: 'Watermark PDF',
            actionLoadingLabel: 'Zaraďujem…',
            publicationHelper: 'Vyhľadávajte iba publikácie, ktoré už majú dostupný PDF súbor na spracovanie.',
            notifications: {
                queuedSuccess: 'PDF úspešne zaradené. Queue ID: %{queueId}',
                failedPrefix: 'Zaradenie PDF watermarku zlyhalo',
            },
        },
        epub: {
            title: 'EPUB podpis (súbor z databázy)',
            heading: 'Podpísať EPUB z databázy',
            description: 'Vyberte publikáciu a zadajte údaje príjemcu pre zaradenie EPUB podpisu do frontu.',
            actionLabel: 'Podpísať EPUB',
            actionLoadingLabel: 'Zaraďujem…',
            publicationHelper: 'Vyhľadávajte iba publikácie, ktoré už majú dostupný EPUB súbor na spracovanie.',
            notifications: {
                queuedSuccess: 'EPUB úspešne zaradené. Queue ID: %{queueId}',
                failedPrefix: 'Zaradenie EPUB podpisu zlyhalo',
            },
        },
        publicationLabel: 'Publikácia',
        consumerSection: 'Informácie o príjemcovi',
        asyncNote: 'Dokument bude spracovaný asynchrónne cez front. Priebeh sledujte v Monitoringu.',
        notifications: {
            selectPublication: 'Vyberte publikáciu',
            publicationsLoadFailed: 'Načítanie publikácií zlyhalo',
        },
    },
    catalog: {
        title: 'Synchronizácia katalógu',
        permissionDenied: 'Prístup iba pre administrátorov.',
        sync: {
            heading: 'Synchronizácia katalógu',
            description: 'Stiahne katalóg z Wolters Kluwer a synchronizuje publikácie v databáze.',
            actionLabel: 'Synchronizovať katalóg',
            actionRunningLabel: 'Prebieha synchronizácia…',
            resultsTitle: 'Výsledky synchronizácie',
            progressTitle: 'Priebeh synchronizácie',
            completed: 'Dokončené',
            stats: {
                total: 'Celkom: %{value}',
                created: 'Vytvorené: %{value}',
                updated: 'Aktualizované: %{value}',
                errors: 'Chyby: %{value}',
            },
            events: {
                tokenMissing: 'Chýba prihlasovací token. Prihláste sa prosím znova.',
                sseInterrupted: 'SSE spojenie prerušené.',
            },
        },
        danger: {
            sectionTitle: 'Nebezpečná zóna',
            cannotBeUndone: '⚠️ Túto akciu nie je možné vrátiť späť',
            confirmPromptSuffix: 'na potvrdenie:',
            confirmInputLabel: 'Napíšte „%{word}" na potvrdenie',
            confirmInputError: 'Musí byť presne „%{word}"',
            cancel: 'Zrušiť',
            deleting: 'Mažem…',
            confirmDelete: 'Potvrdiť zmazanie',
            allFiles: {
                title: 'Zmazať VŠETKY súbory',
                description: 'Trvalo zmaže všetky dokumentové súbory z databázy. Publikácie zostanú v katalógu, ale nebudú mať priradené súbory. Záznamy frontu spracovania zostanú zachované (referencie source_file sú vyčistené).',
                buttonLabel: 'Zmazať všetky súbory',
            },
            allPublications: {
                title: 'Zmazať celý katalóg',
                description: 'Trvalo zmaže VŠETKY publikácie vrátane všetkých ich súborov, fingerprintov dokumentov a verifikácií fingerprintov. Záznamy frontu spracovania a audit podpísaných dokumentov zostanú zachované.',
                buttonLabel: 'Zmazať katalóg',
            },
        },
    },
    massUpload: {
        title: 'Hromadné nahratie dokumentov',
        permissionDenied: 'Prístup iba pre administrátorov.',
        heading: 'Hromadné nahratie dokumentov',
        descriptionPrefix: 'Nahrajte viac PDF alebo EPUB súborov naraz. Názvy súborov musia zodpovedať vzoru',
        descriptionOr: 'alebo',
        descriptionSuffix: '. Súbory s neznámymi SKU budú presкočené. Existujúce súbory budú nahradené.',
        dropZone: {
            filesSelected: 'Vybraných súborov: %{count}',
            placeholder: 'Kliknite alebo pretiahnite súbory sem',
            accepted: 'Povolené: .pdf, .epub',
        },
        actions: {
            upload: 'Nahrať',
            uploadCount: 'Nahrať %{count} súbor(y)',
            uploadingProgress: 'Nahrávanie… (%{progress}%)',
        },
        resultsTitle: 'Výsledky nahrávania',
        progressTitle: 'Priebeh nahrávania',
        completed: 'Dokončené',
        stats: {
            total: 'Celkom: %{value}',
            created: 'Vytvorené: %{value}',
            updated: 'Aktualizované: %{value}',
            skipped: 'Preskočené: %{value}',
            errors: 'Chyby: %{value}',
        },
        events: {
            tokenMissing: 'Chýba prihlasovací token. Prihláste sa prosím znova.',
            starting: 'Spúšťam nahrávanie %{count} súboru(ov)…',
            unknownResponse: 'Neznáma odpoveď',
            networkError: '„%{filename}": chyba siete — %{message}',
            summary: 'Nahrávanie dokončené — Vytvorené: %{created}, Aktualizované: %{updated}, Preskočené: %{skipped}, Chyby: %{errors}, Celkom: %{total}',
        },
    },
    verifyPage: {
        title: 'Verify Pipeline',
        permissionDenied: 'Prístup iba pre administrátorov.',
        heading: 'Verify Pipeline',
        description: 'End-to-end test: Watermark → Fingerprint → Verify → Extract → kontrola manipulácie. Vyberte súbor z databázy alebo použite testovacie súbory.',
        fileSection: {
            title: 'Súbor na overenie',
            selectLabel: 'Vyberte súbor',
            loading: 'Načítavanie súborov…',
            placeholder: '— Vyberte súbor —',
        },
        consumerSection: {
            title: 'Zákaznícke údaje',
            name: 'Meno',
            surname: 'Priezvisko',
            email: 'Email',
            address: 'Adresa',
            phone: 'Telefón',
        },
        actions: {
            start: 'Spustiť verifikáciu',
            running: 'Pipeline beží…',
        },
        progress: {
            stepLabel: 'Krok %{current} / %{total}',
        },
        result: {
            title: 'Výsledok verifikácie',
            verified: 'OVERENÉ ✓',
            notVerified: 'NEOVERENÉ ✗',
            confidence: 'Confidence: %{value}%',
            bits: 'Bitov: %{value}',
            type: 'Typ: %{value}',
            original: 'Originál: %{value} KB',
            final: 'Finálne: %{value} KB',
        },
        log: {
            title: 'Pipeline log',
            completedVerified: 'Dokončené ✓',
            completed: 'Dokončené',
            stepFormat: '── Krok %{step}: %{title} ──',
        },
        errors: {
            tokenMissing: 'Token chýba. Prihláste sa znova.',
            sseInterrupted: 'SSE spojenie prerušené.',
        },
    },
    fingerprintVerify: {
        title: 'Overenie fingerprintu',
        permissionDenied: 'Prístup iba pre administrátorov.',
        heading: 'Overenie fingerprintu dokumentu',
        description: 'Nahrajte PDF alebo EPUB súbor a overte, či obsahuje digitálny fingerprint. Môžete zadať údaje ručne alebo porovnať s databázou.',
        steps: {
            upload: '1. Nahrať súbor',
            mode: '2. Spôsob overenia',
        },
        upload: {
            select: 'Vybrať súbor',
        },
        mode: {
            manual: 'Ručné overenie — zadať Queue ID a/alebo email',
            dbAll: 'Porovnať so všetkými fingerprintmi v databáze',
            dbSpecific: 'Porovnať s konkrétnym fingerprintom z databázy',
        },
        manual: {
            queueIdLabel: 'Queue ID (voliteľné)',
            emailLabel: 'Email zákazníka (voliteľné)',
            queueIdPlaceholder: '550e8400-e29b-41d4-a716-...',
            emailPlaceholder: 'jan.novak@example.sk',
        },
        dbSpecific: {
            selectLabel: 'Vyberte fingerprint z databázy',
            loading: 'Načítavanie…',
            empty: 'Žiadne fingerprinty v databáze',
            placeholder: '— Vyberte fingerprint —',
        },
        dbAll: {
            info: 'Dokument bude porovnaný so všetkými %{count} fingerprintmi v databáze.',
        },
        actions: {
            submit: 'Overiť fingerprint',
            submitting: 'Prebieha overenie…',
        },
        errors: {
            unexpected: 'Neočakávaná chyba',
        },
        extraction: {
            title: 'Extrakcia fingerprintu',
            foundAlert: 'Fingerprint nájdený v dokumente',
            notFoundAlert: 'V dokumente nebol nájdený žiadny fingerprint',
            notFoundSuffix: ' — %{reason}',
            fields: {
                method: 'Metóda',
                queueId: 'Queue ID',
                email: 'Email zákazníka',
                name: 'Meno',
                sku: 'SKU',
                bitsExtracted: 'Bitov extrahovaných',
            },
        },
        verifyResult: {
            title: 'Výsledok verifikácie',
            verified: 'OVERENÉ ✓',
            notVerified: 'NEOVERENÉ ✗',
            confidence: 'Confidence: %{value}%',
            metaOk: 'Metadata ✓',
            metaFail: 'Metadata ✗',
            contentOk: 'Content ✓',
            contentFail: 'Content ✗',
        },
        tamper: {
            title: 'Kontrola integrity (tampering)',
            detected: 'Dokument bol pravdepodobne pozmenený po aplikácii fingerprintu!',
            notDetected: 'Dokument nejaví známky manipulácie',
        },
        dbMatch: {
            title: 'Porovnanie s databázou',
            noFingerprint: 'V dokumente nebol nájdený žiadny fingerprint — nie je možné porovnať s databázou.',
            noMatches: 'Fingerprint nájdený, ale žiadna zhoda v databáze (0 záznamov).',
            matchesFound: 'Nájdených %{count} zhôd v databáze',
            fields: {
                id: 'ID',
                email: 'Email',
                name: 'Meno',
                sku: 'SKU',
                type: 'Typ',
                queueId: 'Queue ID',
                match: 'Zhoda',
            },
            tags: {
                qidOk: 'QID ✓',
                qidFail: 'QID ✗',
                emailOk: 'Email ✓',
                emailFail: 'Email ✗',
            },
        },
    },
};

export default sk;
